import defaultTheme from './default';

const drawerWidth = defaultTheme.drawerWidth;
const drawerBackgroundColor = defaultTheme.DrawerBackgroundColor;
const SideBarStyles = (theme) => {
    return {
      drawerPaper: {
        width: drawerWidth,
       
        backgroundColor: drawerBackgroundColor,
        color: "white",
        borderRight: "0px",
        /*boxShadow:
          "rgba(0, 0, 0, 0.16) 0px 3px 10px, rgba(0, 0, 0, 0.23) 0px 3px 10px",*/
         // boxShadow:'0 0 6px rgba(0,0,0,0.2)',
      },
      
      drawerPaperClose: {
        overflowX: "hidden",
        transition: theme.transitions.create("width", {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: 56,
      },
      logo: {
        cursor: "pointer",
        fontSize: 22,
        color: "white",
        lineHeight: "64px",
        fontWeight: 300,
        backgroundColor: theme.palette.primary[500],
        paddingLeft: 40,
        height: 64,
      },
      avatarRoot: {
                       
        height: 60,
        display: "flex",
        alignItems:"center",
        justifyContent:"center",
        margin:'2rem 0',
      },
      large:{
      width:"80px",
      height:"55px",
      },
      avatarRootMini: {
        padding: "0px 0 0px 0px",
margin:'0',
      },
      small:{
        width:"45px",
        height:"35px",
        },
      avatarIcon: {
        float: "left",
        display: "block",
        boxShadow: "0px 0px 0px 8px rgba(0,0,0,0.2)",
      },
      avatarSpan: {
        paddingTop: 8,
        paddingLeft: 24,
        display: "block",
        color: "white",
        fontWeight: 300,
        textShadow: "1px 1px #444",
      },
      menuItem: {
        color: "black",
        fontSize: 14,
      },
    };
  };

  export default SideBarStyles;